import React from 'react';
import componentStyles from './adCard.module.css';
import globalStyles from '../globals.module.css';
import { trackAdClick, trackAdCtaClick } from '../../utils/adUtils';
import GoogleAd from './googleAd';

/**
 * AdCard Component
 * 
 * A promotional component displayed in the betting feed every 5 bet cards.
 * Visually similar to BetCard with clear 'Sponsored' labeling and orange border highlighting.
 * 
 * Features:
 * - Matches BetCard styling for seamless integration
 * - Orange border and hover effects for visual distinction
 * - Sponsored label for transparency
 * - Click tracking for analytics
 * - CTA button for user actions (upgrade, watch ad, etc.)
 * - Optional image support
 * 
 * @param {string} adId - Unique identifier for ad tracking
 * @param {string} title - Ad title (default: 'StatSpyder Pro')
 * @param {string} description - Ad description text
 * @param {string} ctaText - Call-to-action button text (default: 'Upgrade Now')
 * @param {Function} ctaAction - Function to execute on CTA click
 * @param {boolean} sponsoredLabel - Whether to show sponsored label (default: true)
 * @param {string} adImageUrl - Optional image URL for the ad
 */
const AdCard = ({ 
    adId, 
    title = 'StatSpyder Pro', 
    description = 'Unlock unlimited scouting reports with no ads.', 
    ctaText = 'Upgrade Now', 
    ctaAction, 
    sponsoredLabel = true, 
    adImageUrl 
}) => {

    /**
     * Handle main ad card click for tracking purposes
     * Tracks the click event for analytics and user behavior analysis
     */
    const handleAdClick = () => {
        if (adId) {
            trackAdClick(adId, title);
        }
    };

    /**
     * Handle CTA button click
     * Prevents event bubbling and executes custom action or default upgrade flow
     * @param {Event} e - Click event
     */
    const handleCtaClick = (e) => {
        e.stopPropagation(); // Prevent triggering the main ad click
        if (adId) {
            trackAdCtaClick(adId, title, ctaText);
        }
        
        if (ctaAction) {
            ctaAction();
        } else {
            // Default action - could open upgrade modal or external link
            console.log('CTA clicked - implement upgrade flow');
            // TODO: Implement upgrade modal or redirect to upgrade page
        }
    };

    return (
        <div 
            className={`${componentStyles.adCard} ${globalStyles.slight3dEffect}`} 
            onClick={handleAdClick}
        >
            {/* Sponsored Label - Positioned absolutely in top-right corner */}
            {sponsoredLabel && (
                <div className={componentStyles.sponsoredLabel}>
                    <span>Sponsored</span>
                </div>
            )}
            
            <div className={componentStyles.adCardContent}>
                <GoogleAd />
                {/* Left side - Image or placeholder */}
                {/* <div className={componentStyles.adCardLeft}>
                    {adImageUrl ? (
                        <img src={adImageUrl} alt={title} className={componentStyles.adImage} />
                    ) : (
                        <div className={componentStyles.adImagePlaceholder}>
                            <span>📈</span>
                        </div>
                    )}
                </div> */}
                
                {/* Right side - Content and CTA */}
                {/* <div className={componentStyles.adCardRight}>
                    <h3 className={componentStyles.adTitle}>{title}</h3>
                    <p className={componentStyles.adDescription}>{description}</p>
                    <button 
                        className={componentStyles.ctaButton}
                        onClick={handleCtaClick}
                    >
                        {ctaText}
                    </button>
                </div> */}
            </div>
        </div>
    );
};

export default AdCard; 